import { useMutation, useQueryClient } from "@tanstack/react-query"
import { getOrganizationAxios } from "api-hooks/get-organization-axios"

interface CreateOrganizationParams {
  name: string
  logo_image_base64?: string
}

interface CreateOrganizationResponse {
  organization: {
    organization_id: string
    name: string
    logo_url: string | null
    created_at: string
    updated_at: string
  }
}

export const useCreateOrganization = () => {
  const qc = useQueryClient()

  return useMutation({
    mutationFn: async (
      params: CreateOrganizationParams
    ): Promise<CreateOrganizationResponse> => {
      const axios = getOrganizationAxios()
      const { data } = await axios.post(
        "/seam/console/v1/organizations/create",
        params
      )
      return data
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["organizations"] })
    },
  })
}
